import { IVendorData } from '@/models';
import { IVendorService, IVendorUploadResponseData } from './vendor.types';
import { AxiosInstance } from 'axios';

export class VendorService implements IVendorService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/csi/vendors/';
  }

  fetchVendors(): Promise<IVendorData[]> {
    return this.axios
      .get<IVendorData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchVendor(id: string): Promise<IVendorData> {
    return this.axios
      .get<IVendorData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createVendor(data: IVendorData): Promise<IVendorData> {
    return this.axios
      .post<IVendorData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateVendor(data: IVendorData): Promise<IVendorData> {
    return this.axios
      .patch<IVendorData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteVendor(id: string): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  uploadVendorFile(file: File): Promise<IVendorUploadResponseData> {
    const formData = new FormData();
    formData.append('file_upload', file);

    return this.axios
      .post<IVendorUploadResponseData>(
        `${this.endpoint}upload_file/`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 1000 * 60 * 5 //5mins
        }
      )
      .then(({ data }) => data);
  }
}
